import { z } from 'zod/v3';
import { zIsoDateTime } from '../../common/utils/schema/zIsoDateTime';
import { ProcessingEventDirectoryEntrySchema } from './ProcessingEventDirectoryEntrySchema';
import { transformNullish, zIsoDate } from '../../common/utils';

export const OutputErrorSchema = z.object({
  id: z.number(),
  dataObjectDescriptionId: z.number().nullable(),
  dataObjectDescriptionCode: transformNullish(z.string(), ''),
  dataObjectDescriptionName: transformNullish(z.string(), ''),
  description: transformNullish(z.string(), ''),
  createdAt: zIsoDateTime().nullish(),
});

export const CalculationErrorSchema = OutputErrorSchema.extend({
  algorithmId: z.number().nullable(),
  algorithmCode: transformNullish(z.string(), ''),
  algorithmModifiedAt: zIsoDateTime().nullish(),
  typeId: z.number().nullable(),
  valueDate: zIsoDate().nullish(),
  dataObjectDescriptionVersionId: z.number().nullable(),
  errorCode: z.string().nullish(),
  errorArgs: z.record(z.unknown()).nullish(),
});

export const ValidationErrorSchema = OutputErrorSchema.extend({
  id: z.number(),
  processingDataObjectName: z.string(),
  processingDataObjectDescriptionId: z.number(),
  processingDataObjectDescriptionVersionId: z.number(),
  ruleCode: z.string().nullable(),
  validationRuleId: z.number().nullable(),
  validationRuleModifiedAt: zIsoDateTime().nullish(),
  errorLevelId: z.number(),
  ignoreError: z.boolean(),
  ignoreReason: z.string().nullable(),
  condition: z.string().nullable(),
  expressionLeftHandSide: z.string().nullable(),
  expressionOperatorId: z.number().nullable(),
  expressionRightHandSide: z.string().nullable(),
  tolerance: z.number().nullable(),
  modifiedAt: zIsoDateTime().nullish(),
});

export const MissingSourceDataErrorSchema = OutputErrorSchema.extend({
  sourceDataObjectDescriptionId: z.number().nullable(),
  sourceDataObjectDescriptionCode: transformNullish(z.string(), ''),
  sourceDataObjectDescriptionName: transformNullish(z.string(), ''),
  valueDate: zIsoDate(),
});

export const OutputProcessingEventDetailsSchema = z.object({
  calculationProcessingEvent: ProcessingEventDirectoryEntrySchema.nullable(),
  calculationErrors: CalculationErrorSchema.array(),
  validationProcessingEvent: ProcessingEventDirectoryEntrySchema.nullable(),
  validationErrors: ValidationErrorSchema.array(),
  missingSourceDataProcessingEvent:
    ProcessingEventDirectoryEntrySchema.nullable(),
  missingSourceDataErrors: MissingSourceDataErrorSchema.array(),
});
